module.exports = __webpack_public_path__ + "img/play.45b9359.png";